import essApi from '../axios/essApi';

class PermissionService {
    async getPermissions() {
        return Promise.resolve(essApi.get('permission'))
    }

    async getRolePermission(id) {
        return Promise.resolve(essApi.get(`roles/${id}/permissions`))
    }

    async getDomainPermissions(domain) {
        return Promise.resolve(essApi.get(`domains/${domain}/permissions`));
    }

    async removePermission(roleId, permissionId) {
        return Promise.resolve(essApi.delete(`role/${roleId}/permission/${permissionId}`));
    }

    async createPermissions(reqBody) {
        return Promise.resolve(essApi.post('permission', reqBody))
    }

    async addRolePermission(reqBody) {
        return Promise.resolve(essApi.post('role/permissions', reqBody))
    }
}

export default PermissionService